/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MediaStrictHttpResponse } from '../../media-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyValueModel } from '../../models/key-value-model';

export interface ArticleStatusTypesGet$Plain$Params {
}

export function articleStatusTypesGet$Plain(http: HttpClient, rootUrl: string, params?: ArticleStatusTypesGet$Plain$Params, context?: HttpContext): Observable<MediaStrictHttpResponse<Array<KeyValueModel>>> {
  const rb = new RequestBuilder(rootUrl, articleStatusTypesGet$Plain.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MediaStrictHttpResponse<Array<KeyValueModel>>;
    })
  );
}

articleStatusTypesGet$Plain.PATH = '/Article/StatusTypes';
